<tax-page-header
  titleText="account_payment.title"
  [titleAdditionalInfo]="billingAccountNumber"
  [rightSide]="accountPaymentOptions"
></tax-page-header>

<ng-template #billingAccountNumber>
  <span class="billing-account-number" data-qa="billing-account-number"
    >№{{ organization?.billingAccountNumber }}</span
  >
</ng-template>

<ng-template #accountPaymentOptions>
  <div class="account-payment-options">
    <svg-icon
      key="refresh"
      class="refresh-button"
      (click)="getBalance()"
      data-qa-button="refresh-balance"
    ></svg-icon>
    <div class="balance" *ngIf="balance?.amount || balance?.amount === 0">
      <span data-qa="balance-title">{{ 'personal.account.balance' | translate }}</span>
      <span class="account__title_balance" data-qa="balance-sum">{{
        balance.amount | kzCurrency
      }}</span>
    </div>
    <ng-container *ngIf="organization">
      <button
        *ngIf="organization.billingAccountNumber as billingAccountNumber"
        class="ui-kit-button_link"
        translate
        data-qa-button="replenishment-modal"
        (click)="openPaymentMethodModal(billingAccountNumber)"
      >
        account_payment.fill
      </button>
    </ng-container>
  </div>
</ng-template>

<div class="payment_types" data-qa-filter="payment-types">
  <div
    class="payment_type"
    (click)="showReverseRoll()"
    [ngClass]="{ payment_type__selected: visibility.isSelectedReverseRoll }"
    translate
    data-qa-tag="reverse-roll"
  >
    account_payment.type.turnover
  </div>
  <div
    class="payment_type"
    (click)="showInvoice()"
    [ngClass]="{ payment_type__selected: visibility.isSelectedInvoice }"
    translate
    data-qa-tag="invoices"
  >
    account_payment.type.invoices
  </div>
  <button
    *ngIf="isRootUser"
    data-qa-link="go-to-ismet"
    class="button_blue"
    (click)="getTokenAndRedirect()"
    translate
  >
    ismet.get.token
  </button>
</div>

<div class="date-filter">
  <tax-datepicker
    class="datepicker"
    [(ngModel)]="dateFrom"
    [autofocus]="true"
    (inputEvent)="inputDate($event, 'dateFrom')"
    tabindex="1"
    data-qa-datepicker="start-date"
  ></tax-datepicker>
  <tax-datepicker
    class="datepicker"
    [(ngModel)]="dateTo"
    [startDate]="dateFrom"
    (inputEvent)="inputDate($event, 'dateTo')"
    tabindex="2"
    data-qa-datepicker="end-date"
  ></tax-datepicker>

  <button
    class="button_link"
    [disabled]="visibility.isShowDisabled"
    (click)="showOperations()"
    translate
    data-qa-button="get-operations"
  >
    button.show
  </button>
  <button
    class="button_link operation_month"
    [disabled]="visibility.isShowMonthDisabled"
    (click)="showMonthlyOperations()"
    translate
    data-qa-button="get-operations-by-month"
  >
    account_payment.monthly
  </button>
</div>

<div>
  <div
    data-qa-block="empty-list"
    class="empty_payment_list"
    *ngIf="!reversRoll.length && !invoices.length"
  >
    <span class="empty_payment">
      <svg-icon key="docs"></svg-icon>
      <span class="empty_payment__text" data-qa="empty-list-text">{{
        emptyListPlaceholder | translate
      }}</span>
    </span>
  </div>
  <ng-template [ngIf]="reversRoll" data-qa-block="documents-list">
    <div class="payment_item" *ngFor="let item of reversRoll" data-qa="document">
      <div
        class="payment_date"
        [innerHTML]="item?.docDate | dateFormat | async"
        data-qa="document-date"
      ></div>
      <div class="payment_name" data-qa="document-name">
        <span translate>personal.account.statement</span> {{ item?.invoiceId }}
      </div>
      <div class="payment_operation_type" data-qa="operation-type">
        {{
          (item.typeOperationId == 1
            ? 'organisation.accountStatementInfo.typeOperation.charge'
            : item.typeOperationId == 2
            ? 'organisation.accountStatementInfo.typeOperation.payment'
            : ''
          ) | translate
        }}
      </div>
      <div class="payment_settlement_period" data-qa="period">
        {{ item.calcPeriod }}
      </div>
      <div class="payment_total" data-qa="amount">
        {{ item.amount | kzCurrency }}
      </div>
    </div>
  </ng-template>
  <ng-template [ngIf]="invoices" data-qa-block="documents-list">
    <div
      class="payment_item"
      *ngFor="let item of invoices"
      (click)="openInvoiceModal(item)"
      data-qa="document"
    >
      <div
        class="payment_date"
        [innerHTML]="item?.invoiceDate | dateFormat: 'TRASH' | async"
        data-qa="document-date"
      ></div>
      <div class="payment_name" data-qa="document-name">
        <span translate>personal.account.invoice</span> {{ item?.invoiceId }}
      </div>
      <div class="payment_operation_type">
        <span *ngIf="item.isBase" translate data-qa="operation-type"
          >organisation.accountStatementInfo.base-invoice</span
        >
        <span *ngIf="!item.isBase" translate data-qa="operation-type"
          >organisation.accountStatementInfo.fixed-invoice</span
        >
      </div>
      <div class="payment_settlement_period" data-qa="period">
        {{ item.calcPeriod }}
      </div>
      <div class="payment_total" data-qa="amount">
        {{ item.amount | kzCurrency }}
      </div>
    </div>
  </ng-template>
</div>
